class ProfileService {
  get selectedProvider() {
    return +localStorage.getItem("selected-provider") || -1;
  }

  selectProvider(id) {
    localStorage.setItem("selected-provider", id);
  }
}

const profileService = new ProfileService();
export default profileService;
